export const MY_ACCOUNT = 'MY ACCOUNT';
export const MY_ORDERS = 'MY ORDERS';
export const MY_WALLET = 'MY WALLET';
export const MY_COUPONS = 'MY COUPONS';
export const MY_WISHLIST = 'MY WISHLIST';
export const MY_ADDRESSES = 'MY ADDRESSES';
export const ADD_ADDRESS = 'ADD ADDRESS';
export const EDIT_ADDRESS = 'EDIT ADDRESS';
export const EDIT_PROFILE = 'EDIT PROFILE';
export const MY_SAVED_PAYMENTS = 'MY SAVED PAYMENTS';
export const MY_HELP_CENTER = 'MY HELP CENTER';
export const MY_LOYALTY_PROGRAM = 'MY LOYALTY PROGRAM';
export const RESET_PASSWORD = 'RESET PASSWORD';
export const SAVED_ADDRESSES = 'SAVED ADDRESSES';
export const NEW_ADDRESSES = 'NEW ADDRESSES';
export const ADDRESS_PAGE_TRACKING_ACTION = 'mWeb:myAddresses';
export const MY_ACCOUNT_VIEW = 'myAccount';
export const EDIT_PROFILE_VIEW = 'editProfile';
export const EDIT_ADDRESS_VIEW = 'editAddress';
export const ADD_ADDRESS_VIEW = 'addAddress';
export const MY_ADDRESS_VIEW = 'myAddresses';
export const MY_COUPONS_VIEW = 'myCoupons';
export const SAVED_PAYMENTS = 'savedPayments';
export const LOYALTY_PROGRAM = 'loyaltyProgram';
export const RESET_PASSWORD_KEY = 'resetPassword';
export const ORDERS_LINK = '/sales/order/history/v2';
export const WISHLIST_LINK = '/wishlist/';
export const WALLET_LINK = '/semiClosedWallet';
export const RESET_PASSWORD_LINK = '/user/reset_password';
export const HELP_CENTER_LINK = '/help-center?dl_type=help_center';
export const PRIVE_LINK = '/prive';
export const MY_COUPONS_LINK = '/coupons?root=profile';
export const SELECT_COUNTRY = 'Select Country';
export const SELECT_SHIPPING_COUNTRY = 'SELECT COUNTRY OF SHIPPING';
export const MODAL_STYLE = {
  width: '300px',
  borderRadius: '4px',
};

export const SCREEN_NAV = {
  myAccount: {
    headerName: MY_ACCOUNT,
    navigateBack: MY_ACCOUNT_VIEW,
  },
  myAddresses: {
    headerName: MY_ADDRESSES,
    navigateBack: MY_ACCOUNT_VIEW,
  },
  editAddress: {
    headerName: EDIT_ADDRESS,
    navigateBack: MY_ADDRESS_VIEW,
  },
  addAddress: {
    headerName: ADD_ADDRESS,
    navigateBack: MY_ACCOUNT_VIEW,
  },
  editProfile: {
    headerName: EDIT_PROFILE,
    navigateBack: MY_ACCOUNT_VIEW,
  },
  myCoupons: {
    headerName: MY_COUPONS,
    navigateBack: MY_ACCOUNT_VIEW,
  },
};

export const priveTierImages = {
  silver: 'https://images-static.nykaa.com/media/NewTag.png',
  gold: 'https://images-static.nykaa.com/media/NewTag-1.png',
  platinum: 'https://images-static.nykaa.com/media/NewTag-2.png',
};
export const ORDERS_REVAMP_LINK = '/my/orders';
export const ORDER_VIEW = 'myOrders';
export const MY_ORDERS_PARAMS = {
  PTYPE_PARAM: 'ptype=myOrder',
  SRC_PARAM: 'src=web',
};

export const MY_PROFIE_TITLE = 'My Account';
